<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <!-- <div class="col-sm-12"> -->
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: updateTraining.title,
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: 'Participant Registration',
                      active: true
                    }
                  ]
                    "
              ></vs-breadcrumb>
              <div class="heading mt-3">
                <h3 class="text-secondary">Participant Registration</h3>
              </div>
            </div>
            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Event Information</h6>
              <div class="row col-sm-12">
                <label class="col-sm-1 font-weight-bold">Title:</label>
                <div class="col-sm-11" v-if="updateTraining">{{updateTraining.title}}</div>
              </div>
            </div>
            <vs-tabs alignment="fixed">
              <vs-tab label="Quick Participant Registration">
                <b-card v-if="isForm" style="border: 1px dotted #07a7e14f;">
                  <form @submit.prevent="quickRegistration">
                    <div>
                      <div
                        class="row dblock mt-3"
                        style="padding: 15px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);"
                      >
                        <!--Detail Information starts -->
                        <div class="form-group form-row">
                          <h6 class="sub-frm-title">Information</h6>
                          <div class="row col-sm-12">
                            <div class="col-sm-6 mb-2">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  style="text-transform: default;"
                                  type="text"
                                  placeholder=" "
                                  v-model="name"
                                />
                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                </span>
                                <label class="lbl-label">
                                  Name
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                              </div>
                            </div>
                            <div class="col-sm-6 mb-2">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-mask="'(99999) 9999999-9'"
                                  type="text"
                                  placeholder=" "
                                  v-model="cnic"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i class="material-icons" style="font-size: 20px;">credit_card</i>
                                </span>
                                <label class="lbl-label">
                                  CNIC Number
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                              </div>
                            </div>
                            <div class="col-sm-6 mb-2 mt-3">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-mask="'(9999)-9999999'"
                                  type="text"
                                  placeholder=" "
                                  v-model="mobilenumber"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i class="material-icons" style="font-size: 20px;">call</i>
                                </span>
                                <label class="lbl-label">
                                  Contact
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                              </div>
                            </div>
                            <div class="col-sm-6 mb-2 mt-3">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="passport"
                                  type="text"
                                  placeholder=" "
                                />
                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i class="material-icons" style="font-size: 20px;">credit_card</i>
                                </span>
                                <label class="lbl-label">
                                  Passport
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                              </div>
                            </div>
                            <div class="col-sm-6 mb-2 mt-3">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  type="email"
                                  placeholder=" "
                                  v-model="email"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i class="material-icons" style="font-size: 20px;">email</i>
                                </span>
                                <label class="lbl-label">
                                  Email
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                              </div>
                            </div>
                            <div class="col-md-6 mb-2 col-lg-6 mt-3">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="code"
                                  type="text"
                                  placeholder=" "
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                                >
                                  <i class="material-icons" style="font-size: 20px;">code</i>
                                </span>
                                <label class="lbl-label">
                                  Employee Code (This will use as password)
                                  <span
                                    style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span>
                                </label>
                              </div>
                            </div>
                            <div
                                class="col-sm-4 mt-3"
                                style="padding-left: 5px;display: inline-flex;"
                              >
                                <label
                                  class="col-sm-4 col-form-label"
                                  style="color: #07a7e19c !important;"
                                >
                                  Gender
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                                <div class="col-sm-4" style="margin-top:7px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    style="color: #07a7e19c !important;"
                                    vs-value="male"
                                  >Male</vs-radio>
                                </div>
                                <div class="col-sm-4" style="margin-top:7px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    style="color: #07a7e19c !important;"
                                    vs-value="female"
                                  >Female</vs-radio>
                                </div>
                                <div class="col-sm-6" style="margin-top:7px">
                                  <vs-radio
                                    style="color: #07a7e19c !important;"
                                    v-model="gender"
                                    vs-name="radios1"
                                    vs-value="rather not say"
                                  >Rather not say</vs-radio>
                                </div>
                              </div>
                            <div class="col-sm-6 mt-3">
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  hidden
                                  type="text"
                                  placeholder=" "
                                  v-model="role"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--Detail Information ends -->

                        <!-- save button starts-->
                        <b-button type="submit" class="save-btn" variant="primary">Save</b-button>
                        <!-- save button ends -->
                      </div>
                    </div>
                  </form>
                </b-card>
                  <b-card v-if="isEditForm" style="border: 1px dotted #07a7e14f;">
                <form @submit.prevent="submitEditForm">
                  <div class="form-group">
                    <div class="row">
                      <!-- floating input starts -->
                      <div class="col-sm-6">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            style="text-transform: default;"
                            type="text"
                            placeholder=" "
                            v-model="name"
                          />
                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                          </span>
                          <label class="lbl-label">Name</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            v-mask="'(99999) 9999999-9'"
                            type="text"
                            placeholder=" "
                            v-model="cnic"
                          />

                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">credit_card</i>
                          </span>
                          <label class="lbl-label">CNIC Number</label>
                        </div>
                      </div>
                      <div class="col-sm-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            v-mask="'(9999)-9999999'"
                            type="text"
                            placeholder=" "
                            v-model="mobilenumber"
                          />

                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">call</i>
                          </span>
                          <label class="lbl-label">Contact</label>
                        </div>
                      </div>
                      <div class="col-sm-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            v-model="passport"
                            type="text"
                            placeholder=" "
                          />
                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">credit_card</i>
                          </span>
                          <label class="lbl-label">Passport</label>
                        </div>
                      </div>
                      <div class="col-sm-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            disabled
                            type="email"
                            placeholder=" "
                            v-model="email"
                          />

                          <span
                            class="lbl-label"
                            style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">email</i>
                          </span>
                          <label class="lbl-label">Email</label>
                        </div>
                      </div>
                      <div class="col-md-6 col-lg-6 mt-3">
                        <div class="floating-label">
                          <input
                            class="floating-input form-control"
                            v-model="code"
                            type="text"
                            placeholder=" "
                          />

                          <span
                            class="lbl-label"
                            style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                          >
                            <i class="material-icons" style="font-size: 20px;">code</i>
                          </span>
                          <label class="lbl-label">Employee Code (This will use as password)</label>
                        </div>
                      </div>
                      <div
                                class="col-sm-4 mt-3"
                                style="padding-left: 5px;display: inline-flex;"
                              >
                                <label
                                  class="col-sm-4 col-form-label"
                                  style="color: #07a7e19c !important;"
                                >
                                  Gender
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                                <div class="col-sm-4" style="margin-top:7px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    style="color: #07a7e19c !important;"
                                    vs-value="male"
                                  >Male</vs-radio>
                                </div>
                                <div class="col-sm-4" style="margin-top:7px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    style="color: #07a7e19c !important;"
                                    vs-value="female"
                                  >Female</vs-radio>
                                </div>
                                <div class="col-sm-6" style="margin-top:7px">
                                  <vs-radio
                                    style="color: #07a7e19c !important;"
                                    v-model="gender"
                                    vs-name="radios1"
                                    vs-value="rather not say"
                                  >Rather not say</vs-radio>
                                </div>
                              </div>
                      <!-- Gender ends -->
                    </div>
                  </div>
                  <input type="hidden" v-model="userId" />
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-12">
                        <!-- add button starts-->
                        <b-button pill type="submit" class="save-btn" variant="primary">Update</b-button>
                        <b-button
                          pill
                          v-if="!isForm"
                          @click="closeEditForm"
                          variant="outline-info"
                        >Cancel</b-button>
                        <!-- add button ends -->
                      </div>
                    </div>
                  </div>
                </form>
              </b-card>
                <div class="table-responsive">
                  <div class="col-sm-12">
                    <!-- new form popup starts -->
                    <b-card>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-12">
                            <table class="table table-hover">
                              <tr>
                                <th>Sr#</th>
                                <th>Name</th>
                                <th>CNIC Number</th>
                                <th>Passport</th>
                                <th>Contact Number</th>
                                <th>Email</th>
                                <th>Code</th>
                                <th>Pre</th>
                                <th>Post</th>
                                <th>Action</th>
                              </tr>

                              <tr
                                v-for="(item, index) in itemsTrainee"
                                v-bind:key="item.id"
                              >
                                <td>{{index+1}}</td>
                                <td
                                  v-if="item.name != null"
                                  class="text-capitalize"
                                >{{item.name}}</td>
                                <td v-else>NULL</td>
                                <td v-if="item.cnic != null">{{item.cnic}}</td>
                                <td v-else>NULL</td>
                                <td
                                  v-if="item.passportNo != null"
                                >{{item.passportNo}}</td>
                                <td v-else>NULL</td>
                                <td
                                  v-if="item.contactNo != null"
                                >{{item.contactNo}}</td>
                                <td v-else>NULL</td>
                                <td
                                  v-if="item.username != null"
                                >{{item.username}}</td>
                                <td v-else>NULL</td>
                                <td
                                  v-if="item.code != null"
                                >{{item.code}}</td>
                                <td v-else>NULL</td>
                                <td v-if="item.preassesmentcheck =='found'">
                                  <span>
                                    <vs-icon
                                      class="mr-1"
                                      icon="check"
                                      style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                    ></vs-icon>
                                  </span>
                                </td>
                                <td v-else>
                                  <vs-icon
                                    class="mr-1"
                                    icon="close"
                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </td>
                                <td v-if="item.postassesmentcheck =='found'">
                                  <span>
                                    <vs-icon
                                      class="mr-1"
                                      icon="check"
                                      style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                    ></vs-icon>
                                  </span>
                                </td>
                                <td v-else>
                                  <vs-icon
                                    class="mr-1"
                                    icon="close"
                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </td>
                                <td>
                                  <a @click="editRecord(item.id)">
                                    <vs-icon
                                      class="mr-4"
                                      icon="edit"
                                      style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                    ></vs-icon>
                                  </a>
                                  <a @click="deleteRecord(item.id)">
                                    <vs-icon
                                      class="mr-1"
                                      icon="delete"
                                      style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                    ></vs-icon>
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </b-card>
                    <!-- new form popup ends -->
                  </div>
                </div>
              </vs-tab>

            

              <vs-tab label="Detail Participant Registration">
                <div class="col-sm-12">
                  <!-- ======================= -->
                  <!-- tabs starts -->
                  <form @submit.prevent="detailsRegistration">
                    <div>
                      <vs-tabs
                        v-model="tabIndex"
                        alignment="fixed"
                        :color="colorx='rgba(7, 167, 225, 0.61)'"
                      >
                        <vs-tab
                          icon="person"
                          @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                          label="Basic Information"
                          style="margin-top:30px;display:block !important;"
                        >
                          <div class="con-tab-ejemplo">
                            <!-- Basic Information starts -->
                            <div class="form-group form-row">
                              <h6 class="sub-frm-title">Basic Information</h6>
                              <!-- floating input starts -->
                              <div class="col-sm-12">
                                <div class="alert alert-success" v-if="success">{{ success }}</div>
                                <div class="alert alert-danger" v-if="error">{{ error }}</div>
                                <div class="floating-label">
                                  <input
                                    class="floating-input form-control"
                                    style="text-transform: default;"
                                    v-model="name"
                                    type="text"
                                    placeholder=" "
                                  />

                                  <span
                                    class="lbl-label"
                                    style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                  >
                                    <i
                                      class="material-icons"
                                      style="font-size: 20px;"
                                    >account_circle</i>
                                  </span>
                                  <label class="lbl-label">
                                    Full Name
                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                  </label>
                                </div>
                              </div>
                              <div class="col-sm-6 mt-3">
                                <label
                                  style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                >
                                  Select Identity
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                                <selectize id="select-state" v-model="whichSelect">
                                  <option
                                    v-for="(item,index) in options1"
                                    :key="index"
                                    :value="item.value"
                                  >{{item.text}}</option>
                                </selectize>
                              </div>
                              <div class="col-sm-6 mt-45" v-if="whichSelect == 0">
                                <div class="floating-label">
                                  <input
                                    class="floating-input form-control"
                                    v-model="passport"
                                    type="text"
                                    placeholder=" "
                                  />
                                  <span
                                    class="lbl-label"
                                    style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                  >
                                    <i class="material-icons" style="font-size: 20px;">credit_card</i>
                                  </span>
                                  <label class="lbl-label">
                                    Passport
                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                  </label>
                                </div>
                              </div>
                              <div class="col-sm-6 mt-45" v-if="whichSelect == 1">
                                <div class="floating-label">
                                  <input
                                    class="floating-input form-control"
                                    v-mask="'(99999) 9999999-9'"
                                    v-model="cnic"
                                    type="text"
                                    placeholder=" "
                                  />

                                  <span
                                    class="lbl-label"
                                    style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                  >
                                    <i class="material-icons" style="font-size: 20px;">credit_card</i>
                                  </span>
                                  <label class="lbl-label">
                                    CNIC Number
                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                  </label>
                                </div>
                              </div>

                              <!-- Gender starts -->
                              <div
                                class="col-sm-4 mt-3"
                                style="padding-left: 5px;display: inline-flex;"
                              >
                                <label
                                  class="col-sm-4 col-form-label"
                                  style="color: #07a7e19c !important;"
                                >
                                  Gender
                                  <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                </label>
                                <div class="col-sm-4" style="margin-top:7px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    style="color: #07a7e19c !important;"
                                    vs-value="male"
                                  >Male</vs-radio>
                                </div>
                                <div class="col-sm-4" style="margin-top:7px">
                                  <vs-radio
                                    v-model="gender"
                                    vs-name="radios1"
                                    style="color: #07a7e19c !important;"
                                    vs-value="female"
                                  >Female</vs-radio>
                                </div>
                                <div class="col-sm-6" style="margin-top:7px">
                                  <vs-radio
                                    style="color: #07a7e19c !important;"
                                    v-model="gender"
                                    vs-name="radios1"
                                    vs-value="rather not say"
                                  >Rather not say</vs-radio>
                                </div>
                              </div>
                              <!-- Gender ends -->
                              <!-- Address starts -->
                              <div class="row" style="width:100%">
                                <div class="col-sm-6 mt-3">
                                  <div class="floating-label">
                                    <input
                                      class="floating-input form-control"
                                      v-model="mobilenumber"
                                      v-mask="'(9999)-9999999'"
                                      type="text"
                                      placeholder=" "
                                    />

                                    <span
                                      class="lbl-label"
                                      style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                    >
                                      <i class="material-icons" style="font-size: 20px;">local_phone</i>
                                    </span>
                                    <label class="lbl-label">
                                      Mobile Number
                                      <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </label>
                                  </div>
                                </div>
                                <div class="col-sm-6 mt-3">
                                  <div class="floating-label">
                                    <input
                                      class="floating-input form-control"
                                      v-model="email"
                                      v-on:blur="EmailValidation()"
                                      type="email"
                                      :name="email"
                                      placeholder=" "
                                    />

                                    <span
                                      class="lbl-label"
                                      style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                    >
                                      <i class="material-icons" style="font-size: 20px;">email</i>
                                    </span>
                                    <label class="lbl-label" :for="email" name="email">
                                      Email
                                      <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </label>
                                    <!-- <h3> {{name}}</h3> -->
                                  </div>
                                </div>
                                <!-- <div class="col-sm-4 mt-3">
                                <label
                                  style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                >Country <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <selectize id="select-state" v-model="country">
                                  <option
                                    v-for="(item,index) in countryArr"
                                    :key="index"
                                    :value="item.id"
                                  >{{item.title}}</option>
                                </selectize>
                                </div>-->
                                <!-- <div class="col-sm-4 mt-3">
                                <label
                                  style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                >Province <span style="color:rgba(255, 0, 0, 0.78);">*</span></label>
                                <selectize id="select-state" v-model="province">
                                  <option
                                    v-for="(item,index) in provinceArr"
                                    :key="index"
                                    :value="item.id"
                                  >{{item.title}}</option>
                                </selectize>
                                </div>-->

                                <div class="col-sm-12 mt-3">
                                  <label
                                    style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;"
                                  >
                                    District
                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                  </label>
                                  <selectize id="select-state" v-model="district">
                                    <option
                                      v-for="(item,index) in districtArr"
                                      :key="index"
                                      :value="item.id"
                                    >{{item.title}}, {{item.province.title}}, {{item.province.country.title}}</option>
                                  </selectize>
                                </div>
                                <!-- floating input starts -->
                                <div class="col-sm-12 mt-3">
                                  <div class="floating-label">
                                    <input
                                      class="floating-input form-control"
                                      v-model="address"
                                      type="text"
                                      placeholder=" "
                                    />

                                    <span
                                      class="lbl-label"
                                      style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                    >
                                      <i class="material-icons" style="font-size: 20px;">place</i>
                                    </span>
                                    <label class="lbl-label">
                                      Address
                                      <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </label>
                                  </div>
                                </div>
                                <!-- floating input ends -->
                              </div>
                              <!-- Address ends -->
                            </div>
                            <!-- Basic Information ends -->
                          </div>
                          <!-- next button starts-->
                          <b-button @click="tabIndex++" class="save-btn" variant="primary">Next</b-button>
                          <!-- next button ends -->
                        </vs-tab>
                        <vs-tab
                          icon="business_center"
                          @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                          label="Employment Information"
                        >
                          <div class="con-tab-ejemplo">
                            <!--Employment Information starts -->
                            <div class="form-group form-row">
                              <h6 class="sub-frm-title mt-3">Employment Information</h6>
                              <!-- Accademic Qualification starts -->
                              <div class="col-sm-12">
                                <!-- <h6 style="color:#212529;font-size:15px;">Accademic Qualification</h6> -->
                                <div class="table-responsive-sm">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <th scope="col" style="color: #07a7e19c !important;">
                                          Department Name
                                          <span
                                            style="color:rgba(255, 0, 0, 0.78);"
                                          >*</span>
                                        </th>
                                        <!-- <th scope="col">Degree Name</th>
                                        <th scope="col">Degree Subject</th>-->
                                        <th scope="col" style="color: #07a7e19c !important;">
                                          Designation / Rank
                                          <span
                                            style="color:rgba(255, 0, 0, 0.78);"
                                          >*</span>
                                        </th>
                                        <!-- <th scope="col"></th> -->
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <div>
                                            <selectize id="select-state" v-model="department">
                                              <option
                                                v-for="(item,index) in departmentArr"
                                                :key="index"
                                                :value="item.id"
                                              >{{item.title}}</option>
                                            </selectize>
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                           
                                            <div class="floating-label">
                                              <input
                                                class="floating-input form-control"
                                                v-model="designation"
                                                type="text"
                                                placeholder=" "
                                              />

                                              <span
                                                class="lbl-label"
                                                style="float: right;margin-top: -25px;padding: 0px 5px;color:#ccc;"
                                              ></span>
                                              <label class="lbl-label">Designation</label>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="col" style="color: #07a7e19c !important;">
                                          Employee Code/Password
                                          <span
                                            style="color:rgba(255, 0, 0, 0.78);"
                                          >*</span>
                                        </th>
                                      </tr>
                                      <tr>
                                        <td>
                                          <div>
                                            <input
                                              style="line-height: 3; height: 36px; box-shadow: none !important; height: calc(1.3em + 0.75rem + 2px)"
                                              type="text"
                                              v-model="code"
                                              class="form-control"
                                              id="inputtext"
                                              placeholder
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            <div class="col-sm-6 mt-3">
                                              <div class="floating-label">
                                                <input
                                                  class="floating-input form-control"
                                                  hidden
                                                  type="text"
                                                  placeholder=" "
                                                  v-model="role"
                                                />

                                                <span
                                                  class="lbl-label"
                                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                                ></span>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <!-- Accademic Qualification ends -->
                            </div>
                            <!--Employment Information ends -->
                          </div>
                          <!-- next button starts-->
                          <b-button @click="tabIndex++" class="save-btn" variant="primary">Next</b-button>
                          <!-- next button ends -->
                          <!-- next button starts-->
                          <b-button
                            @click="tabIndex--"
                            class="previous-btn"
                            variant="primary"
                          >Previous</b-button>
                          <!-- next button ends -->
                        </vs-tab>
                        <vs-tab
                          icon="school"
                          @click="colorx = 'rgba(7, 167, 225, 0.61)'"
                          label="Academic Qualification"
                        >
                          <div class="con-tab-ejemplo">
                            <!--Academic Qualification (Last Attended Degree) starts -->
                            <div class="form-group form-row">
                              <h6
                                class="sub-frm-title mt-3"
                              >Academic Qualification (Last Attended Degree)</h6>
                              <!-- Employment Record starts -->
                              <div class="col-sm-12">
                                <div class="table-responsive-sm">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <th scope="col" style="color: #07a7e19c !important;">
                                          Degree / Certificate
                                          <span
                                            style="color:rgba(255, 0, 0, 0.78);"
                                          >*</span>
                                        </th>
                                        <th scope="col" style="color: #07a7e19c !important;">
                                          Passing Year
                                          <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </th>
                                        <th scope="col" style="color: #07a7e19c !important;">
                                          University / Institute / School
                                          <span
                                            style="color:rgba(255, 0, 0, 0.78);"
                                          >*</span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <div>
                                            <selectize id="select-state" v-model="certificate">
                                              <option
                                                v-for="(item,index) in degreenameArr"
                                                :key="index"
                                                :value="item.id"
                                              >{{item.title}}</option>
                                            </selectize>
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            <input
                                              style="line-height: 3; height: 36px; box-shadow: none !important"
                                              type="text"
                                              v-model="passing_year"
                                              v-mask="9999"
                                              class="form-control"
                                              id="inputtext"
                                              placeholder
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div>
                                            <input
                                              style="line-height: 3; height: 36px; box-shadow: none !important"
                                              type="text"
                                              v-model="institute"
                                              class="form-control"
                                              id="inputtext"
                                              placeholder
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <!-- Employment Record ends -->
                            </div>
                            <!--Academic Qualification (Last Attended Degree) ends -->
                          </div>
                          <!-- next button starts-->
                          <!-- <b-button @click="tabIndex++" class="save-btn" variant="primary">Next</b-button> -->
                          <b-button type="submit" class="save-btn" variant="primary">Save</b-button>
                          <!-- next button ends -->
                          <!-- next button starts-->
                          <b-button
                            @click="tabIndex--"
                            class="previous-btn"
                            variant="primary"
                          >Previous</b-button>
                        </vs-tab>
                      </vs-tabs>
                    </div>
                  </form>
                  <!-- tabs ends -->
                  <!-- ======================= -->
                </div>
              </vs-tab>
              <vs-tab label="Registered Trainee">
                <div class="table-responsive">
                  <div class="col-sm-12">
                    <!-- new form popup starts -->
                    <b-card>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-12">
                            <table class="table table-hover">
                              <tr style="color: #07a7e19c !important;">
                                <th>Sr#</th>
                                <th>Name</th>
                                <th>CNIC Number</th>
                                <th>Passport</th>
                                <th>Email</th>
                                <th>Code</th>
                                <th>Pre</th>
                                <th>Post</th>
                                <th>Action</th>
                              </tr>
                              <tr
                                v-for="(item, index) in registeredTrainerArr"
                                v-bind:key="item.id"
                              >
                                <td>{{index+1}}</td>
                                <td v-if="item.name != null" class="text-capitalize">{{item.name}}</td>
                                <td v-else>NULL</td>
                                <td v-if="item.cnic != null">{{item.cnic}}</td>
                                <td v-else>NULL</td>
                                <td v-if="item.passport != null">{{item.passport}}</td>
                                <td v-else>NULL</td>
                                <td v-if="item.email != null">{{item.email}}</td>
                                <td v-else>NULL</td>
                                <td v-if="item.code != null">{{item.code}}</td>
                                <td v-else>NULL</td>
                                <td v-if="item.preassesmentcheck =='found'">
                                  <span>
                                    <vs-icon
                                      class="mr-1"
                                      icon="check"
                                      style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                    ></vs-icon>
                                  </span>
                                </td>
                                <td v-else>
                                  <vs-icon
                                    class="mr-1"
                                    icon="close"
                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </td>
                                <td v-if="item.postassesmentcheck =='found'">
                                  <span>
                                    <vs-icon
                                      class="mr-1"
                                      icon="check"
                                      style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                    ></vs-icon>
                                  </span>
                                </td>
                                <td v-else>
                                  <vs-icon
                                    class="mr-1"
                                    icon="close"
                                    style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                  ></vs-icon>
                                </td>
                                <td v-if="item.status =='found'">
                                  <span>
                                    <a @click="unassignedTraining(item.id)" class="unassign_training">
                                      <vs-chip color="danger">Un Assign</vs-chip>
                                    </a>
                                  </span>
                                </td>
                                <td v-else>
                                  <a @click="assignedTraining(item.id)" class="assign_training">
                                    <vs-chip color="success">Assign Training</vs-chip>
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </b-card>
                    <!-- new form popup ends -->
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Selectize from "vue2-selectize";
import Sidebar from "./subSidebar";
import axios from "axios";

export default {
  data: () => ({
    isSidebar: false,
    whichSelect: 0,
    role: "",
    designation: "",
    valuesArray: [],
    options1: [
      { text: "Passport", value: 0 },
      { text: "CNIC", value: 1 }
    ],
    radios1: "",
    gender: "",
    success: "",
    passport: "",
    institute: "",
    passing_year: "",
    certificate: "",
    district: "",
    email: "",
    error: "",
    isEditForm: "",
    cnic: "",
    inValid: [],
    updateTraining: [],
    isForm: true,
    isFormData: false,
    selected: "",
    tabIndex: 0,
    contact_person: "",
    contact_number: "",
    contact_email: "",
    address: "",
    primaryUserId: "",
    userId:"",
    components: {
      // VueTagsInput
    },
    country: 1,
    province: 1,
    tag: "",
    tags: [],
    rolesArr: [],
    registeredTrainerArr: [],
    trainingId: "",
    trainingCode: "",
    roleuser: "",
    departmentArr: [],
    department: "",
    designationArr: [],
    sessionByArray: [],
    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    textarea: "",
    counterDanger: false,
    mydate: "",
    trainingCheck: false,
    repeatedCheck: false,
    select1Normal: "",
    select1: 0,
    select2: 1,
    select3: 0,
    select4: 1,
    select5: 1,
    select6: 1,
    select7: 1,
    select8: 1,
    select9: 1,
    select10: 0,
    select11: 1,
    select12: 1,
    select13: 1,
    select14: 1,
    code: "",
    name: "",
    mobilenumber: "",
    thematicareaSelected: "",
    thematicareasettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    traineridentityArr: [
      { text: "CNIC Number", value: 1 },
      {
        text: "Passport Number",
        value: 2
      }
    ],

    languageskillsArr: [
      { text: "English", value: 1 },
      { text: "French", value: 2 },
      { text: "German", value: 3 },
      { text: "Chinese", value: 4 }
    ],
    selectlevelArr: [
      { text: "Good", value: 1 },
      { text: "Very Good", value: 2 },
      { text: "Excellent", value: 3 },
      { text: "Weak", value: 4 }
    ],
    countryArr: [],
    trainingArr: [],
    provinceArr: [],
    districtArr: [],
    degreenameArr: [],
    degreesubjectArr: [
      { text: "Management Science", value: 1 },
      { text: "Computer Science", value: 2 },
      { text: "Software Engineering", value: 3 }
    ],
    jobnatureArr: [
      { text: "Permanent", value: 1 },
      { text: "Temporary", value: 2 }
    ],
    itemsTrainee: [],
    items: [
      {
        contact_person: "Dr Saif Ullah",
        department: "Police Dedpartment KP",
        city: "Mardan"
      },

      {
        contact_person: "Dr Ata Ullah",
        department: "Police Dedpartment ISLAMABAD",
        city: "Peshawar"
      }
    ],
    fields: [
      { key: "city", label: "City" },
      { key: "department", label: "Department" },
      { key: "contact_person", label: "Contact Person" },
      { key: "actions", label: "" }
    ]
  }),
  watch: {
    country(val) {
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/provinces/get/" + val
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.provinceArr = response.data;
        });
    },
    province(val) {
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/districts/get/" + val
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.districtArr = response.data;
        });
    }
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    //Select all countries

    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.updateTraining = response.data.training;
        this.trainingId = response.data.training.id;
        this.allTrainer();
        this.getAllTraining();
      });
    /* this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/countries/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.countryArr = response.data;
        // this.provinceArr=response.data;
      }); */
    //get result of trainers
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainers/all/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.valuesArray = response.data;
      });

    //select all provinces
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/provinces/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.provinceArr = response.data;
      });
    //select all district
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/districts/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.districtArr = response.data;
      });
    //select all degree names
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/degreenames/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.degreenameArr = response.data;
      });
    // department
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/departments/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.departmentArr = response.data;
      });
    //designation
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/designations/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.designationArr = response.data;
      });
    // axios.get(localStorage.getItem("BASE_PATH")+'/trainers/get').then(response => {
    //   this.sessionByArray = response.data;
    // });
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/traineeroles/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.role = response.data[0].id;
      });
    //select all Training Name
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainers/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingArr = response.data;
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    Selectize
  },

  methods: {
    unassignedTraining(id) {
      this.openLoading();
      axios
        .post(
          localStorage.getItem("BASE_PATH") +
            "/training/officer/un-assigned/trainee",
          {
            trainingId: this.trainingId,
            trainee: id
          }
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            this.$toasted.global.successMsg("Training Un Assigned successfully!");
            this.getAllTraining();
          }
        });
    },
    assignedTraining(id) {
      this.openLoading();
      axios
        .post(
          localStorage.getItem("BASE_PATH") +
            "/training/officer/assigned/trainee",
          {
            trainingId: this.trainingId,
            trainee: id
          }
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            this.$toasted.global.successMsg("Assigned Training successfully!");
            this.getAllTraining();
          }
        });
    },
    closeEditForm() {
      this.isForm = true;
      this.isEditForm = false;
      this.resetForm();
    },
    editRecord(id) {
      this.isForm = false;
      this.isEditForm = true;
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") + "/trainee/user/" + id + "/edit"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.name = response.data.userstrainee.name;
            this.code = response.data.userstrainee.code;
            this.mobilenumber = response.data.userstrainee.contactNo;
            this.email = response.data.userstrainee.username;
            this.cnic = response.data.cnic;
            this.passport = response.data.passportNo;
            this.gender = response.data.gender;
            this.userId = id;
            this.primaryUserId = response.data.user_trainee_id;
            // this will scrollTop to edit form
            window.scrollTo(0, 0);
          }
        });
    },
    deleteRecord(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(localStorage.getItem("BASE_PATH") + "/trainee/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allTrainer();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    getAllTraining() {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainee/get/all/fortraining/" +
            this.trainingId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.registeredTrainerArr = response.data;
        });
    },
    allTrainer: function allTrainer() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") + "/trainee/show/" + this.trainingId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();

          this.itemsTrainee = response.data;
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    showinputvalue: function(event) {
      this.name = event.target.value;
    },
    detailsRegistration(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.gender) {
        this.inValid.push("Gender type is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number utype is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      if (!this.country) {
        this.inValid.push("Country type is required.");
      }
      if (!this.province) {
        this.inValid.push("Province type is required.");
      }
      if (!this.district) {
        this.inValid.push("District type is required.");
      }
      if (!this.address) {
        this.inValid.push("Address type is required.");
      }
      if (!this.designation) {
        this.inValid.push("Designation type is required.");
      }
      if (!this.certificate) {
        this.inValid.push("Certificate type is required.");
      }
      if (!this.passing_year) {
        this.inValid.push("Passing Year type is required.");
      }
      if (!this.institute) {
        this.inValid.push("Institute type is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/register/trainee", {
            //insert user information in user table
            name: this.name,
            code: this.code,
            department_name: this.department,
            role: this.role,
            gender: this.gender,
            contactNo: this.mobilenumber,
            email: this.email,
            sessionBy: this.trainingId,
            statusApproval: 2,
            //insert trainee information
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            passport: this.passport,
            country: this.country,
            province: this.province,
            district: this.district,
            address: this.address,
            certificate: this.certificate,
            passing_year: this.passing_year,
            designation: this.designation,
            institute: this.institute,
            type: "Details Registration"
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allTrainer();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    //Quick training
    quickRegistration(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      if (!this.gender) {
        this.inValid.push("Gender is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/register/trainee", {
            //insert User informatiion in user table
            name: this.name,
            code: this.code,
            role: this.role,
            contactNo: this.mobilenumber,
            email: this.email,
            gender : this.gender,
            sessionBy: this.trainingId,
            //insert trainee quick information in trainee table
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            statusApproval: 2,
            passport: this.passport,
            type: "Quick Registration"
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been added successfully!");
              self.resetForm();
              self.allTrainer();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    submitEditForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/trainee/update", {
            //insert User informatiion in user table

            name: this.name,
            code: this.code,
            role: this.role,
            contactNo: this.mobilenumber,
            email: this.email,
            //insert trainee quick information in trainee table
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            gender : this.gender,
            passport: this.passport,
            type: "Quick Registration",
            id: this.userId,
            primaryUserId: this.primaryUserId
          })

          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              self.allTrainer();
              this.isForm = true;
              this.isEditForm = false;
            } else if (response.data.error) {
              self.toastError(response.data.error);
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    resetForm() {
      this.name = "";
      this.cnic = "";
      this.code = "";
      this.passport = "";
      this.gender = "";
      this.mobilenumber = "";
      this.email = "";
      this.country = "";
      this.province = "";
      this.district = "";
      this.address = "";
      this.department_name = "";
      this.designation = "";
      this.certificate = "";
      this.passing_year = "";
      this.institute = "";
    },
    successUpload() {
      this.$vs.notify({
        color: "primary",
        title: "Upload Success",
        text: "Your file is uploaded Successfully."
      });
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.mt-45 {
  margin-top: 45px !important;
}
button:focus {
  outline: transparent !important;
  outline: transparent -webkit-focus-ring-color !important;
}
a.assign_training {
  cursor: pointer;
}
a.unassign_training {
  cursor: pointer;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #ffffff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.previous-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: left;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #fff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
/****  floating-Lable style end ****/
/* Floating label css ends */

.add-btn {
  font-size: 25px;
  color: rgba(7, 167, 225, 0.61);
  cursor: pointer;
}
.delete-btn {
  font-size: 25px;
  color: rgba(255, 0, 0, 0.78);
  cursor: pointer;
}
</style>
